export const LABELS = {
	SCAN_SUMMARY_SR_LABEL: 'Scan summary',
	TOTAL_ISSUES: 'Total Issues',
	COMPONENTS: 'Components',
	PAGES_SCANNED: 'Pages scanned',
	PAGES_WITH_ISSUES: 'Pages with issues'
};
